import { css } from 'emotion';
import React, { useState } from 'react';
import Field from 'redux-form/lib/Field';
import { FieldDatetimeWithRedux as FieldDatetime } from 'components/FieldDatetime/FieldDatetimeWithRedux';
import { Caret } from '../../shared/Caret';
import {
  Container,
  PseudoLabel,
  ButtonSectionContainer,
  StyledButton,
  CalendarLabel,
  Dropdown,
  DropdownWrapper,
  StyledModal,
  ModalContentContainer,
  PublishDateDisplay,
  LocalTimezoneMessage,
} from './styles';
import { getDisplayValue, roundToNextHour } from './utils';

/** With Redux */
const FieldDatePicker = ({
  setValue,
  value,
  label,
  name = 'publishOn',
  className,
}: {
  setValue?: (date: string | null) => void;
  value?: string | null;
  label: string;
  name?: string;
  className?: any;
}) => {
  const [isShowingSchedulerModal, setIsShowingSchedulerModal] = useState(false);

  const handleReset = () => {
    if (setValue) {
      setValue(null);
    }
    setIsShowingSchedulerModal(false);
  };
  return (
    <Container className={className}>
      <PseudoLabel aria-label={name}>{label}</PseudoLabel>
      <DropdownWrapper>
        <button
          onClick={() => setIsShowingSchedulerModal(true)}
          type="button"
          aria-label="Open date selector"
        >
          <Dropdown>
            <PublishDateDisplay>
              {getDisplayValue(value, null, 'Now')}
            </PublishDateDisplay>
            <Caret color="#5f6369" />
          </Dropdown>
        </button>
      </DropdownWrapper>
      <StyledModal
        isShowing={isShowingSchedulerModal}
        onClickClose={handleReset}
        isShowingCloseButton
        renderContent={() => (
          <ModalContentContainer>
            <CalendarLabel htmlFor={name}>
              {getDisplayValue(value, 'Schedule for', 'Publish now')}
              <Field
                component={FieldDatetime}
                name={name}
                normalize={roundToNextHour}
              />
            </CalendarLabel>
            <LocalTimezoneMessage>All times are local</LocalTimezoneMessage>
            <ButtonSectionContainer>
              <StyledButton
                kind="button"
                onClick={handleReset}
                className={css`
                  color: #5000b9;
                `}
              >
                Reset to now
              </StyledButton>
              <StyledButton
                kind="button"
                color="purple"
                onClick={() => setIsShowingSchedulerModal(false)}
              >
                Confirm
              </StyledButton>
            </ButtonSectionContainer>
          </ModalContentContainer>
        )}
      />
    </Container>
  );
};

export { FieldDatePicker };
export { ControlledFieldDatePicker } from './ControlledFieldDatePicker';
